import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const DoctorRoot = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.neutrals.beige2,
  borderRadius: theme.shape.borderRadius,
  padding: `12px 24px`,
  display: 'flex',
  justifyContent: 'space-between'
}));

export const DoctorRootTitle = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between'
}));

export const DoctorRootPhoto = styled(Box)(() => ({
  width: 60,
  height: 60,
  borderRadius: '50%',
  overflow: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

export const ButtonWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  gap: theme.spacing(2),

  [theme.breakpoints.down('sm')]: {
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
}));
